<ion-content *ngIf="isLoading; else mainContent" fullscreen>
  <div class="loader-container">
    <ion-spinner name="dots"></ion-spinner>
    <app-logo [width]="300"></app-logo>
    <ion-spinner name="dots"></ion-spinner>
  </div>
</ion-content>

<ng-template #mainContent>
  <ion-app >
    <ion-router-outlet></ion-router-outlet>
  </ion-app>
</ng-template>
